<script>
  const links = [
    { href: '/privacy-policy', label: 'Privacy Policy' },
    { href: '/terms', label: 'Terms' },
    { href: '/disclaimer', label: 'Disclaimer' },
    { href: '/about', label: 'About' },
    { href: '/contact', label: 'Contact' },
    { href: '/credit', label: 'Credits' }
  ]
</script>

<footer class={$$restProps.class || ''}>
  <span>All content & design © Pokémon Nuzlocke Tracker, 2021-{(new Date()).getFullYear()}.</span>
  <nav aria-label="Footer">
    {#each links as { href, label }, i}
      <a {href}>{label}</a>{#if i < links.length - 1}<span aria-hidden="true">·</span>{/if}
    {/each}
  </nav>
  <br class='hidden md:block' />
  Pokémon images & names © 1995-2024 Nintendo/Creatures Inc./GAME FREAK inc. TM
</footer>

<!-- svelte-ignore css-unused-selector -->
<style>
  footer { @apply text-center w-full absolute bottom-4 md:bottom-2 sm:my-6 px-4 text-tiny md:text-xs text-gray-500 dark:text-gray-400 leading-3 z-20 h-max; }
  footer nav { @apply mt-1 flex flex-wrap justify-center gap-x-2 gap-y-1; }
  footer > p { @apply flex justify-center text-2xl gap-x-2; }
  footer a,
  footer button { @apply transition-colors; }
  footer button:hover, footer a:hover, { @apply text-black }
  :global(.dark) footer button:hover, :global(.dark) footer a:hover { @apply text-white }
  footer button { @apply p-3 }
</style>
